export const version = "units/5.4.0";
//# sourceMappingURL=_version.js.map